export default {
    namespaced: true,
    state: {
        selectedDates: [],
    },
    getters: {
        getDatesByProjectId(state) {
            return (id) => {
                if (state.selectedDates && state.selectedDates.length) {
                    let selectedProject = state.selectedDates.find((date) => date.projectId == id)
                    if (selectedProject && selectedProject.dates) {
                        return selectedProject.dates
                    }
                }

                return []
            }
        },
    },
    actions: {
        setDates(ctx, obj) {
            ctx.commit('UPDATE_DATES', obj)
        },
        reset(ctx) {
            ctx.commit('RESET')
        },
    },
    mutations: {
        UPDATE_DATES(state, value) {
            let isInArray = false

            state.selectedDates.forEach((obj, index) => {
                if (obj.projectId == value.projectId) {
                    isInArray = true
                    state.selectedDates[index].dates = value.dates
                }
            })
            if (!isInArray) state.selectedDates.push(value)
        },
        RESET(state) {
            state.selectedDates = []
        },
    },
}
